import React, { useEffect, useRef, useState } from 'react';
import { IonContent, IonPage, IonButton, IonAlert } from '@ionic/react';
import { _dict } from '../constants';
import { useGlobalStore } from '../stateManagement/globalZustand';

interface LayoutPageProps {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: (layoutName: string|number) => void; // Added prop for external confirm handler
  initialLayoutName: string | number;
}

const SaveLayoutModal: React.FC<LayoutPageProps> = ({ onDismiss, onConfirm, isOpen, initialLayoutName }) => {
  const { lang } = useGlobalStore();
  const [showAlert, setShowAlert] = useState<boolean>(isOpen);
  const [layoutName, setLayoutName] = useState<string | number>(initialLayoutName);
  const alertVisibleRef = useRef<boolean>(false);

  useEffect(() => {
    // When showAlert changes and is true, focus the input after a small delay
    if (showAlert && !alertVisibleRef.current) {
      alertVisibleRef.current = true; // Mark as processing to avoid refocusing on every render

      setTimeout(() => {
        // Attempt to find the input field by its class or placeholder - this is fragile
        const inputElement = document.querySelector('ion-alert input') as HTMLInputElement | null;
        if (inputElement) inputElement.focus();
        alertVisibleRef.current = false; // Reset for the next time the alert is shown
      }, 500); // Adjust the delay as needed
    }
  }, [showAlert]);

  useEffect(() => {
    setShowAlert(isOpen);
  }, [isOpen])

  const handleConfirm = (layoutName: string | number) => {
    onConfirm(layoutName); // Call external confirm handler
  };

  

  return (
    
      <IonAlert
        isOpen={showAlert}
        onDidDismiss={onDismiss}
        header={'Save Layout'}
        inputs={[
          {
            name: 'layoutName',
            type: 'text',
            placeholder: 'Layout Name',
            value: layoutName, // Ensure the input is controlled
          },
        ]}
        buttons={[
          {
            text: _dict.undo[lang],
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: _dict.storeLayout[lang],
            handler: (alertData) => {
              // Directly use the layout name from alertData to confirm
              handleConfirm(alertData.layoutName);
            }
          }
        ]}
        message={_dict.pleaseEnterANameBeforeSaving[lang]}
      />
  );
};

export default SaveLayoutModal;
